'use client';
import { useLocale, useTranslations } from 'next-intl';
import { ErrorState, Link } from '@/components/ui';
import { useEventFollows } from './EventFollowProvider';
export function EventFollowStatus({ following = false }: { following?: boolean }) {
  const f = useEventFollows();
  const t = useTranslations('Event.follow');
  const locale = useLocale();
  if (f.unavailable) return null;
  if (f.error)
    return (
      <ErrorState variant="inline" message={t('error')} onRetry={f.retry} retryLabel={t('retry')} />
    );
  if (following && f.ready && !f.userId)
    return (
      <Link
        href={`/${locale}/login?redirect=${encodeURIComponent(typeof window === 'undefined' ? `/${locale}` : window.location.pathname + window.location.search)}`}
      >
        {t('signInFollowing')}
      </Link>
    );
  if (following && !f.ready)
    return (
      <p role="status" className="text-muted text-sm">
        {t('loading')}
      </p>
    );
  return null;
}
